import React from 'react';

const TeachersListSkeletonLoader: React.FC = () => {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '24px'
    }}>
      {[...Array(12)].map((_, index) => (
        <div
          key={index}
          style={{
            borderRadius: '20px',
            border: '1px solid #e5e7eb',
            background: 'white',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            padding: '32px 24px 24px',
            animation: 'pulse 1.5s ease-in-out infinite',
            animationDelay: `${index * 0.1}s`
          }}
        >
          <div style={{ textAlign: 'center' }}>
            {/* Avatar skeleton */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite',
              margin: '0 auto 20px',
              border: '4px solid #fafbfc'
            }}></div>

            {/* Name skeleton */}
            <div style={{
              height: '24px',
              width: '60%',
              margin: '0 auto 12px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}></div>

            {/* Badge skeleton */}
            <div style={{
              height: '28px',
              width: '40%',
              margin: '0 auto 24px',
              borderRadius: '20px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}></div>

            {/* Divider */}
            <div style={{
              height: '1px',
              background: '#f3f4f6',
              marginBottom: '16px'
            }}></div>

            {/* Contact info skeletons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{
                height: '40px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
              <div style={{
                height: '40px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeachersListSkeletonLoader;
